import React, { Component } from 'react'
import './BankDetails.css'
let bankdetails = 'Details not available'
class BankDetails extends Component {
    constructor(props) {
        super(props)
    }
    componentWillReceiveProps(nextProps){
        bankdetails=nextProps.transporter_data.bank_details;
        if(bankdetails==undefined || bankdetails==null){
            bankdetails='Details not available'
        }
    }
    render() {
        if(bankdetails.bank_approved=="yes" || bankdetails.bank_approved=="Yes" || bankdetails.bank_approved=="1" || bankdetails.bank_approved==1){
        return (
            <>
            <div className="bankdetailscard">
            <div className="bankdetailscontainer">
                <span className="data_header"><b>Bank Details</b></span>
                { (bankdetails=='Details not available')?(<p style={{marginLeft:'2%'}}>Details not available</p>):(
                <div className="bankdetailsrow">
                <div className="bankdetailscolumn">
                    <div className="bankDetails_screen"><b>Bank Approved:</b> Yes</div>
                    <div>
                    <div className="bankDetails_screen">{(bankdetails.bank_name)?(<><b>{bankdetails.bank_name} </b></>):('')}</div>
                    <div className="bankDetails_screen_lower"> {(bankdetails.iba_registration_number)?(<><b>Reg No:{bankdetails.iba_registration_number}</b></>):('')}</div>
                    </div>
                </div>
                <div className="bankdetailscolumn">
                    <div className="bankDetails_screen"> {(bankdetails.bank_guarantee)?(<><b>Bank Guarantee: &#x20b9;</b> {bankdetails.bank_guarantee}</>):('')}</div>
                    <div className="bankDetails_screen"> {(bankdetails.pan_card)?(<><b>Pan Card No:</b> {bankdetails.pan_card}</>):('')}</div>
                </div>
                </div>)}
            </div>
            </div>
            {/* <div className="bankdetailscard">
            <div className="bankdetailscontainer row">
                <div className="col-12">
                <span className="data_header">Bank Details</span>
                </div>
                { (bankdetails=='Details not available')?(<div>Details not available</div>):(
                <table>
                    <tr>
                    <td className="bankDetails_screen"><b>Bank Approved:</b> Yes</td>
                    <td className="bankDetails_screen"><b>{bankdetails.bank_name}|Reg No:</b>{bankdetails.iba_registration_number}</td>
                    </tr>
                    <tr>
                    <td className="bankDetails_screen" align="right"><b>Bank Guarantee: &#x20b9;</b> {bankdetails.bank_guarantee}</td>
                    <td className="bankDetails_screen"><b>Pan Card No:</b> {bankdetails.pan_card}</td>
                    </tr>
                </table>)}
            </div>
            </div> */}
            </>
        )
        }
        else{
            return(
                <>
                <div className="bankdetailscard">
                <div className="bankdetailscontainer row">
                    <div className="col-12">
                    <span className="data_header">Bank Details</span>
                    </div>
                    { (bankdetails=='Details not available' || !bankdetails.pan_card)?(<p style={{marginLeft:'2%'}}>Details not available</p>):(
                    <div className='col'>
                    <div className="bankDetails_screen">{(bankdetails.pan_card)?(<><b>Pan Card No:</b> {bankdetails.pan_card}</>):('')}</div>
                    </div>)}
                </div>
                </div>
                </>
            )
        }
    }
}

export default BankDetails

